export default function slugify(str) {
	if (!str || typeof str !== 'string') {
		return str;
	}
	return str.normalize().replace(/[^\w\s$*_+~.()'"!\-:@]+/g, '').trim().replace(/\s+/g, '-').toLowerCase();
}